module.exports = __webpack_public_path__ + "img/3.df12dbad.jpg";